import { DigitalTextFieldCell } from "@website/ui/digital-text-field/digital-text-field-cell";
import { useDigitalTextField } from "@website/ui/digital-text-field/digital-text-field.hook";
import styles from "@website/ui/digital-text-field/digital-text-field.module.scss";
import { DigitalTextFieldPropertiesType } from "@website/ui/digital-text-field/digital-text-field.types";
import { deepCompare } from "@website/utils/deep-compare";
import { FC, memo } from "react";

const DigitalTextField: FC<DigitalTextFieldPropertiesType> = (properties) => {
  const { className, error, helperText, num } = properties;
  const { inputProps, cellsProps } = useDigitalTextField(properties);

  const cellsList: Array<JSX.Element> = [];
  for (let index = 0; index < num; index++) {
    cellsList.push(<DigitalTextFieldCell {...cellsProps[index]} key={index} />);
  }

  return (
    <div
      className={`${styles["digital-text-field"]} ${
        error ? styles["error"] : ""
      } ${className ?? ""}`}
    >
      <input className={styles["digital-text-field-input"]} {...inputProps} />
      <div className={styles["digital-text-field-box"]}>{cellsList}</div>
      {helperText ? (
        <div className={styles["digital-text-field-helper-text"]}>
          {helperText}
        </div>
      ) : null}
    </div>
  );
};

const DigitalTextFieldMemoized = memo(DigitalTextField, deepCompare);
export { DigitalTextFieldMemoized as DigitalTextField };
